
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import './LoadingBar.scss'

const TIME_TO_CLOSE = 2e3
let closeTimeout = null

const LoadingBar = ({ loadingBarParams }) => {
  const { total, first, second, onClose } = loadingBarParams
  const [isEnable, setIsEnable] = useState(false)
  const percent = total / 100
  const firstWidth = `${first / percent}%`
  const secondWidth = `${second / percent}%`
  const isStart = first === 0 && second === 0
  const isFinished = first === total && (second === 0 || second === total)

  /* auto open/close */
  if (isFinished) {
    if (isEnable && !closeTimeout) {
      closeTimeout = setTimeout(() => {
        clearTimeout(closeTimeout)
        closeTimeout = null
        setIsEnable(false)
      }, TIME_TO_CLOSE)
    } else if (onClose) onClose()
  } else {
    if (!isEnable) setIsEnable(true)
    if (closeTimeout) {
      clearTimeout(closeTimeout)
      closeTimeout = null
    }
  }
  return (
    <div className="loadingBar" style={{ height: isEnable ? '0.4em' : '0em' }}>
      <span className="loadingBar-first" style={{ width: firstWidth, transition: isStart ? '0s' : '0.5s' }} />
      <span className="loadingBar-second" style={{ width: secondWidth, transition: isStart ? '0s' : '0.5s' }} />
    </div>
  )
}

LoadingBar.propTypes = {
  loadingBarParams: PropTypes.object.isRequired,
};

export default connect(
  state => ({
    loadingBarParams: state.app.loadingBarParams,
  }),
  dispatch => bindActionCreators({}, dispatch),
)(LoadingBar);
